<template>
  <div class="basic-information">
    <div class="info-left">
      <div class="info-left-top">
        <div>
          <h1>{{custInfo.custName}}</h1>
          <p>{{custInfo.riskLevel | riskLevelFilter}}</p>
        </div>
        <ul>
          <li>性别： {{custInfo.gender | genderFilter}}</li>
          <li>证件号码： {{custInfo.idCard | moneyFixed}}</li>
          <li>年龄： {{custInfo.custAge}}岁</li>
          <li>出生日期： {{custInfo.custBirthDay}}</li>
        </ul>
      </div>
      <div class="info-left-bottom">
        <ul>
          <li>
            <p>学历</p>
            <el-select v-model="educationValue"
                       placeholder="请选择"
                       @change="handleSelectChange(educationValue, workValue, knowledgeValue, experienceValue)">
              <el-option v-for="item in educationSelect"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </li>
          <li>
            <p>职业</p>
            <el-select v-model="workValue"
                       placeholder="请选择"
                       @change="handleSelectChange(educationValue, workValue, knowledgeValue, experienceValue)">
              <el-option v-for="item in workSelect"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </li>
          <li>
            <p>投资经验</p>
            <el-select v-model="experienceValue"
                       placeholder="请选择"
                       @change="handleSelectChange(educationValue, workValue, knowledgeValue, experienceValue)">
              <el-option v-for="item in experienceSelect"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </li>
          <li>
            <p>投资知识</p>
            <el-select v-model="knowledgeValue"
                       placeholder="请选择"
                       @change="handleSelectChange(educationValue, workValue, knowledgeValue, experienceValue)">
              <el-option v-for="item in knowledgeSelect"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </li>
        </ul>
      </div>
    </div>
    <div class="info-right">
      <div class="graphContainer">
        <yh-graph ref="graph"
                  class="graph"
                  style="width:500px;height:400px;display:inline-block;"
                  @select-link="onLinkSelect">
        </yh-graph>
        <div  @click="addnewRel">
 <img src="../../../assets/images/wpsp/add.png"
             class="add"
             />
<span class="addText">新增家庭成员</span>
        </div>

      </div>
    </div>
    <div class="rel-form">
      <!-- 修改关系================================= -->
      <yh-dialog title="修改家庭成员"
                 :visible.sync="editing">
        <el-form :model="rel"
                 ref="editRelationShip"
                 label-width="80px"
                 class="yh-small"
                 :rules="relRules">
          <el-form-item label="姓名"
                        prop="target"
                        class="is-required">
            <el-input v-model="rel.target"
                      size="mini"
                      style="width:200px;"
                      minlength="2"></el-input>
          </el-form-item>
          <el-form-item label="年龄"
                        prop="age">
            <el-input v-model="rel.age"
                      size="mini"
                      style="width:200px;"
                      clearable>
            </el-input>
          </el-form-item>
          <el-form-item label="关系"
                        prop="name">
            <el-select v-model="rel.name"
                       size="mini"
                       style="width:200px;">
              <el-option v-for="item in options"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="证件类型"
                        prop="a">
            <el-select v-model="rel.idType"
                       size="mini"
                       style="width:200px;">
              <el-option v-for="item in idTypeOptions"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
                {{item.label}}
              </el-option>
            </el-select>
            <div style="overflow:hidden;padding-top: 8px;">
              <transition name="verificationText-style">
                <p class="verificationText"
                   v-if="verificationTextShowIdType">{{verificationTextShowIdTypeText}}</p>
              </transition>
            </div>
          </el-form-item>
          <el-form-item label="证件号码"
                        prop="b">
            <el-input type="age"
                      v-model="rel.idCode"
                      size="mini"
                      placeholder="请输入证件号码"
                      style="width:200px;"></el-input>
            <div style="overflow:hidden;padding-top: 8px;">
              <transition name="verificationText-style">
                <p class="verificationText"
                   v-if="verificationTextShowIdCode">{{verificationTextShowIdCodeText}}</p>
              </transition>
            </div>
          </el-form-item>
          <div style="text-align: right;">
            <yh-button class="yh-primary"
                       @click="onDelClick"
                       style="background-color: #FEEDED;border: 1px solid #FDBBBB;border-radius: 4px;font-size: 14px;color: #F95353;">删除</yh-button>
            <yh-button class="yh-primary"
                       @click="editing=false"
                       style="border-radius: 4px;font-size: 14px;color: #333;">取消</yh-button>
            <yh-button class="yh-primary"
                       @click="onSaveClick"
                       style="background-color: #1E88FF;border-radius: 4px;font-size: 14px;color: #fff;">确定</yh-button>
          </div>
        </el-form>
      </yh-dialog>
      <!-- 新增 -->
      <!-- :rules="rules" -->
      <yh-dialog title="新增家庭成员"
                 :visible.sync="showform">
        <el-form :model="rel"
                 label-width="80px"
                 class="yh-small mt-5  text-left "
                 ref="relForm"
                 :rules="relRules">
          <el-form-item label="姓名"
                        prop="target"
                        class="is-required">
            <el-input v-model="rel.target"
                      size="mini"
                      style="width:200px;"
                      placeholder="请输入姓名，不超过50位"
                      minlength="2"></el-input>
          </el-form-item>
          <el-form-item label="年龄"
                        prop="age"
                        class="is-required">
            <el-input type="age"
                      v-model="rel.age"
                      size="mini"
                      placeholder="请输入年龄，不超过3位"
                      style="width:200px;"></el-input>
          </el-form-item>
          <el-form-item label="关系"
                        prop="name">
            <el-select v-model="rel.name"
                       size="mini"
                       style="width:200px;"
                       placeholder="请选择">
              <el-option v-for="item in options"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="证件类型">
            <el-select v-model="rel.idType"
                       size="mini"
                       style="width:200px;"
                       placeholder="请选择">
              <el-option v-for="item in idTypeOptions"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
                {{item.label}}
              </el-option>
            </el-select>
            <div style="overflow:hidden;padding-top: 8px;">
              <transition name="verificationText-style">
                <p class="verificationText"
                   v-if="verificationTextShowIdType">{{verificationTextShowIdTypeText}}</p>
              </transition>
            </div>
          </el-form-item>
          <el-form-item label="证件号码">
            <el-input type="age"
                      v-model="rel.idCode"
                      size="mini"
                      placeholder="请输入证件号码"
                      style="width:200px;"></el-input>
            <div style="overflow:hidden;padding-top: 8px;">
              <transition name="verificationText-style">
                <p class="verificationText"
                   v-if="verificationTextShowIdCode">{{verificationTextShowIdCodeText}}</p>
              </transition>
            </div>
          </el-form-item>
          <p style="text-align:right">
            <el-button @click="resetForm"
                       size="small">取消</el-button>
            <el-button type="primary"
                       @click="onConfirmSubmit"
                       size="mini">确定
            </el-button>
          </p>
        </el-form>
      </yh-dialog>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import graph from './Graph.vue';

export default {
  name: 'basic-information',
  components: {
    'yh-graph': graph,
  },
  data() {
    // eslint-disable-next-line consistent-return
    const validatorAge = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入年龄'));
      }
      if (value.toString().length > 1) {
        if (value.toString().slice(0, 1) === '0' && value.toString().slice(1, 2) !== '.') {
          return callback('首位不为零');
        }
      }
      if (!/^\d+$/g.test(value) || value === '0') {
        return callback('请输入正整数');
      }
      if (value.toString().length > 3) {
        return callback('年龄不可超过3位');
      }

      callback();
    };
    // eslint-disable-next-line consistent-return
    const validatorTarget = (rule, value, callback) => {
      console.log(value, '姓名');
      if (value === '') {
        callback(new Error('请输入成员姓名'));
      }
      if (/[^a-zA-Z\u4E00-\u9FA5.]/.test(value)) {
        return callback('成员姓名不可包含特殊符号和数字');
      }
      if (value.length > 50) {
        return callback('成员姓名不可超过50位');
      }
      callback();
    };
    return {
      verificationTextShowIdType: false,
      verificationTextShowIdTypeText: false,
      verificationTextShowIdCode: false,
      verificationTextShowIdCodeText: false,
      educationSelect: [
        {
          value: '1',
          label: '博士',
        },
        {
          value: '2',
          label: '硕士',
        },
        {
          value: '3',
          label: '本科',
        },
        {
          value: '4',
          label: '专科',
        },
        {
          value: '5',
          label: '高中',
        },
        {
          value: '6',
          label: '其他',
        },
      ],
      workSelect: [
        {
          value: '1',
          label: '纯文职人员',
        },
        {
          value: '2',
          label: '部分文职人员',
        },
        {
          value: '3',
          label: '外出工作人员',
        },
        {
          value: '4',
          label: '体力劳动者',
        },
        {
          value: '5',
          label: '重体力劳动者',
        },
        {
          value: '6',
          label: '危险职业',
        },
        {
          value: '7',
          label: '高危职业',
        },
      ],
      knowledgeSelect: [
        {
          value: '1',
          label: '有专业执照',
        },
        {
          value: '2',
          label: '财经专业毕业',
        },
        {
          value: '3',
          label: '自修有心得',
        },
        {
          value: '4',
          label: '懂一些',
        },
        {
          value: '5',
          label: '一片空白',
        },
      ],
      experienceSelect: [
        {
          value: '1',
          label: '无',
        },
        {
          value: '2',
          label: '1年以内',
        },
        {
          value: '3',
          label: '1~2年',
        },
        {
          value: '4',
          label: '2~5年',
        },
        {
          value: '5',
          label: '6~10年',
        },
        {
          value: '6',
          label: '10年以上',
        },
      ],
      // educationValue  学历
      // workValue  职业
      // knowledgeValue  投资知识
      // experienceValue  投资经验
      educationValue: '',
      workValue: '',
      knowledgeValue: '',
      experienceValue: '',
      // 从这开始是关系图
      custInfo: {}, // 客户基本信息
      validateObj: {}, // 存放客户id
      riskTolerance: '',
      riskType: '',
      tempRel: '',
      tempIdType: '',
      tempIdCode: '',
      allfamilyList: [],
      timmer: '',
      tempAge: '', // 临时存放的age
      showerror: false,
      custLevel: null,
      opration: '2', // 1 新增  2 修改 3 删除
      relRules: {
        target: [
          { required: true, validator: validatorTarget, trigger: ['blur'] },
        ],
        age: [
          { required: true, validator: validatorAge, trigger: ['blur'] },
        ],
        name: [{
          required: true, message: '请选择关系', trigger: 'blur',
        }],

      },
      options: [
        {
          label: '配偶',
          value: '配偶',
        },
        {
          label: '父亲',
          value: '父亲',
        },
        {
          label: '母亲',
          value: '母亲',
        },
        {
          label: '儿子',
          value: '儿子',
        },
        {
          label: '女儿',
          value: '女儿',
        },
      ],
      fileNamePDF: '',
      uploadFilePDF: '',
      cost: [],
      year: [],
      filePath: '',
      datetime: '',
      dated: '',
      tempLinkName: '', // 临时存放关系名称
      isHidden: false, // 财富规划显示隐藏
      custInfoSupple: {
        education: '', // 学历
        marriage: '', // 婚姻状况
        occupation: '', // 职业
        investKnowledge: '', // 投资知识
        socialSecurityLocation: '', // 社保所在地
        investExperience: '', // 投资经验
      }, // 客户补充信息
      education: '', // 学历
      occupation: '', // 职业
      investknowledge: '', // 投资知识
      investexperience: '', // 投资经验
      socialSecurityLocation: '', // 社保所在地
      custCis: '', // 客户cis号
      custFamilyMember: '', // 客户家庭成员信息
      custBasicInfo: '', // 客户基本信息
      showform: false, // 新建角色
      rel: {
        id: '', // 人员id
        source: '',
        age: null,
        target: '', // 对应关系
        oldName: '',
        name: '', // 关系姓名
        idType: '', // 证件类型
        idCode: '', // 身份证号码
        //  targetId: ''
      },
      componentData: { // 人物关系组件传递数据
        // cis: JSON.parse(sessionStorage.getItem('custCis')).cis, // 客户cis号
        cis: this.custCis, // 客户cis号
        // cis: '',
        familys: [],

      },
      templateInfo: '', // 第三部分的家庭基本信息
      editing: false, // 编辑角色关
      graph: {},
      img: '',
      targetName: '', // 点击节点后 目标结点的名字
      idTypeOptions: [{
        label: '居民身份证',
        value: '1',
      },
      {
        label: '军官证',
        value: '2',
      }, {
        label: '护照',
        value: '3',
      }],
    };
  },
  watch: {
    showform: {
      immediate: true,
      handler(val, oldVal) {
        console.log(val, oldVal, '新增弹窗状态');
        if (val === false) {
          this.verificationTextShowIdType = false;
          this.verificationTextShowIdTypeText = '';
          this.verificationTextShowIdCode = false;
          this.verificationTextShowIdCodeText = '';
        }
      },
    },
    editing: {
      immediate: true,
      handler(val) {
        if (val === false) {
          this.verificationTextShowIdType = false;
          this.verificationTextShowIdTypeText = '';
          this.verificationTextShowIdCode = false;
          this.verificationTextShowIdCodeText = '';
          this.$refs.editRelationShip.resetFields();
        }
      },
    },
  },
  created() {
    this.custCis = JSON.parse(sessionStorage.getItem('cis')); // 获取客户cis号
  },
  mounted() {
    this.$refs.graph.show(this.graph);
    // this.queryCustBaseInfo();
  },
  methods: {
    // 查询客户基本信息相关
    // queryCustBaseInfo() {
    //   const parames = {
    //     data: { // 类型：Object  必有字段  备注：数据集
    //       cis: this.custCis, // 类型：String  必有字段  备注：客户号
    //       uId: JSON.parse(sessionStorage.getItem('sessionData')).userId,
    //     },
    //   };
    //   this.$_post(this.$API.wpspGetCustInfo, parames).then((res) => {
    //     // 加载完子传父
    //     this.$emit('toParent', res);
    //     if (res.status === '0') {
    //       // 客户基本信息初始化赋值
    //       this.custInfo = res.data.info;
    //       sessionStorage.setItem('custInfo', JSON.stringify(res.data.info));
    //       this.$store.commit('setUserInfo', res.data.info);
    //       this.educationValue = res.data.info.education;
    //       this.workValue = res.data.info.occupation;
    //       this.knowledgeValue = res.data.info.investKnowledge;
    //       this.experienceValue = res.data.info.investExperience;
    //       console.log('接口---查询客户基本信息', res.data.info);
    //       this.$store.commit('setUserInfo', res.data.info);
    //       const age = res.data.info.custAge;
    //       const { custName } = res.data.info;
    //       const sex = res.data.info.gender;
    //       let image = '';
    //       if (sex === '2' || sex === 2) {
    //         image = './images/people/woman.png';
    //       } else if (sex === '1' || sex === 1) {
    //         image = './images/people/man.png';
    //       }
    //       console.log('图片', image);
    //       let combine = '';
    //       if (custName.length <= 10 && custName.length > 5) {
    //         // eslint-disable-next-line no-useless-concat
    //         combine = `${custName.slice(0, 5)} \n ${custName.slice(5)}[${age}岁` + ']';
    //       } else if (custName.length < 20 && custName.length > 10) {
    //         // eslint-disable-next-line no-useless-concat
    //         combine = `${custName.slice(0, 6)} \n ${custName.slice(6, 12)} \n ${custName.slice(12)}[${age}岁` + ']';
    //       } else {
    //         // eslint-disable-next-line no-useless-concat
    //         combine = `${custName}[${age}岁` + ']';
    //       }
    //       this.graph = {
    //         nodes: [{
    //           id: '0',
    //           name: combine,
    //           age,
    //           size: 60,
    //           image,
    //           // eslint-disable-next-line no-useless-concat
    //           trueName: `${custName}[${age}岁` + ']',
    //         }],
    //         links: [],
    //       };
    //       this.$refs.graph.show(this.graph);
    //       this.queryDefaultRelation();
    //     } else {
    //       this.$message({
    //         message: res.errorMsg,
    //         type: 'error',
    //       });
    //     }
    //   });
    // },
    //  请求默认关系
    queryDefaultRelation() {
      const parames = {
        data: { // 类型：Object  必有字段  备注：数据集
          cis: this.custCis, // 类型：String  必有字段  备注：客户号
          uId: JSON.parse(sessionStorage.getItem('sessionData')).userId,
        },
      };
      this.$_post(this.$API.wpspListCustSupple, parames).then((res) => {
        console.log('接口---查询客户家庭成员信息', res);
        this.allfamilyList = res.data.allCustSupple;
        const familiList = res.data.allCustSupple;
        this.$store.commit('setFamiliList', res.data.allCustSupple);
        console.warn('*****************', res);
        const arr = res.data.allCustSupple;
        arr.forEach((item) => {
          console.log(item);
          if (item.custRelation === '1') {
            this.$store.commit('setAddSpouse', '2');
            console.log('**----', this.$store.state.wpspAddSpouse);
          }
        });
        if (familiList) {
          // eslint-disable-next-line array-callback-return
          familiList.map((v) => {
            const age = v.custAge;
            const customerRelation = v.custRelation;
            const gender = v.custRelation;
            const { custName } = v;
            const { id } = v;
            const { idType } = v;
            const idCode = v.idCard;
            const NewCustomerRelation = this.relationWithNum(customerRelation);
            this.onSaveAdd(age, NewCustomerRelation, gender, custName, id, idType, idCode);
          });
        }
      });
    },
    // 与客户关系 中文转数字
    relationWithCis(rel) {
      let val = null;
      if (rel) {
        switch (rel) {
          case '配偶':
            val = 1;
            break;
          case '父亲':
            val = 2;
            break;
          case '母亲':
            val = 3;
            break;
          case '儿子':
            val = 4;
            break;
          case '女儿':
            val = 5;
            break;
          default: break;
        }
      }
      return val;
    },
    // 与客户关系 // 数字转中文
    relationWithNum(num) {
      let val = null;
      if (num) {
        switch (num) {
          case '1':
            val = '配偶';
            break;
          case '2':
            val = '父亲';
            break;
          case '3':
            val = '母亲';
            break;
          case '4':
            val = '儿子';
            break;
          case '5':
            val = '女儿';
            break;
          default: break;
        }
      }
      return val;
    },
    // --fenjie
    resetForm() {
      this.$refs.relForm.resetFields();
      this.showform = false;
    },
    // 新增子女
    async onConfirmSubmit() {
      // eslint-disable-next-line consistent-return
      this.$refs.relForm.validate((valid) => {
        if (valid) {
          if (this.rel.idType === '' && this.rel.idCode !== '') {
            this.verificationTextShowIdType = true;
            this.verificationTextShowIdTypeText = '请选择证件类型';
            return false;
          }
          this.verificationTextShowIdType = false;
          this.verificationTextShowIdTypeText = '';
          if (this.rel.idType !== '' && this.rel.idCode === '') {
            this.verificationTextShowIdCode = true;
            this.verificationTextShowIdCodeText = '请输入证件号码';
            return false;
          }
          if (this.rel.idCode.length > 50) {
            this.verificationTextShowIdCode = true;
            this.verificationTextShowIdCodeText = '证件号码不可超过50位';
            return false;
          }
          if (this.rel.idType === '1' || this.rel.idType === 1) {
            const reg = /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/;
            const idCard = reg.test(this.rel.idCode);
            // 验证身份证是否符合规范
            if (idCard === false) {
              this.verificationTextShowIdCode = true;
              this.verificationTextShowIdCodeText = '请输入18位有效的身份证号';
              return false;
            }
          }
          this.verificationTextShowIdCode = false;
          this.verificationTextShowIdType = false;
          const parames = {
            data: { // 类型：Object  必有字段  备注：数据集
              cis: this.custCis, // 类型：String  必有字段  备注：客户号
              custName: this.rel.target, // 类型：String  必有字段  备注：家庭成员姓名
              custRelation: this.relationWithCis(this.rel.name), // 类型：String  必有字段
            },
          };
          this.$_post(this.$API.wpspCheckChildName, parames).then(async (res) => {
            console.log('验证姓名', res);
            console.log('客户信息-rel:', this.rel);
            if (res.status === '0') {
              const parame = {
                data: { // 类型：Object  必有字段  备注：数据集
                  cis: this.custCis, // 类型：String  必有字段  备注：客户号
                  custName: this.rel.target, // 类型：String  必有字段  备注：姓名
                  custAge: this.rel.age, // 类型：Number  必有字段  备注：年龄
                  custRelation: this.relationWithCis(this.rel.name), // 类型：String  必有字段  备注：关系(1、配偶 2、父亲3、母亲4、儿子5、女儿)
                  idType: this.rel.idType, // 类型：String  可有字段  备注：证件类型(1、居民身份证 2、军官证3、护照)
                  idCard: this.rel.idCode, // 类型：String  可有字段  备注：证件号码
                  uId: JSON.parse(sessionStorage.getItem('sessionData')).userId,
                },
              };
              const resolve = await this.wpspGetCustInfoFn(parame);
              console.log(resolve, '新增家庭关系');
              if (resolve.status === '0') {
                this.$message({
                  message: '成功',
                  type: 'success',
                });
                const paramesData = {
                  data: {
                    cis: this.custCis, // 类型：String  必有字段  备注：客户号
                  },
                };
                this.$_post(this.$API.wpspListCustSupple, paramesData).then((val) => {
                  if (val.status === '0') {
                    const relationWith = this.relationWithCis(this.rel.name).toString();
                    // eslint-disable-next-line array-callback-return,consistent-return
                    const obj = val.data.list.filter((v) => {
                      if (this.rel.target === v.custName && relationWith === v.custRelation) {
                        return v;
                      }
                    });
                    const customerRelation = obj[0].custRelation;
                    const age = obj[0].custAge;
                    const gender = obj[0].custRelation;
                    const idCode = obj[0].idCard;
                    const { custName, id, idType } = obj[0];
                    const NewCustomerRelation = this.relationWithNum(customerRelation);
                    console.log('添加关系', this.rel.name);
                    if (this.rel.name === '配偶') {
                      this.$store.commit('setAddSpouse', '2');
                    }
                    this.$refs.graph.updateLinkName(id, NewCustomerRelation, gender, custName, idType, idCode);
                    this.onSaveAdd(age, NewCustomerRelation, gender, custName, id, idType, idCode);
                  } else {
                    this.$message({
                      message: res.errorMsg,
                      type: 'error',
                    });
                  }
                });
              } else {
                this.$message({
                  message: resolve.errorMsg,
                  type: 'error',
                });
              }
            } else {
              this.$message({
                message: res.errorMsg,
                type: 'error',
              });
            }
          });
        }
      });
    },
    wpspGetCustInfoFn(parame) {
      return new Promise((resolve) => {
        this.$_post(this.$API.wpspSaveFamilySupple, parame).then((res) => {
          resolve(res);
        }).catch(error => console.log(error));
      });
    },
    async onLinkSelect(link) { // 节点点击方法
      this.$forceUpdate();
      console.log('link;', link);
      this.validateObj = link;
      if (this.tempRel !== undefined && this.tempRel != null && this.tempRel !== '') {
        if (this.tempRel.idType !== this.allfamilyList[link.id].idType) {
          this.rel.idType = this.tempRel.idType;
        } else {
          this.rel.idType = this.allfamilyList[link.id].idType;
        }
        if (this.tempRel.idCode !== this.allfamilyList[link.id].idCode) {
          this.rel.idCode = this.tempRel.idCode;
        } else {
          this.rel.idCode = this.allfamilyList[link.id].idCode;
        }
      } else {
        this.rel.idType = this.allfamilyList[link.id].idType;
        this.rel.idCode = this.allfamilyList[link.id].idCode;
      }
      this.tempIdType = this.allfamilyList[link.id].idType;
      this.tempIdCode = this.allfamilyList[link.id].idCode;
      this.tempLinkName = link.id;
      this.targetName = link.target.name; // 选中结点 目标角色名字
      const reg = new RegExp(/(\d+)/, 'g');
      reg.exec(link.target.name);
      this.rel.age = RegExp.$1;
      this.tempAge = RegExp.$1;
      const r = this.rel;
      r.id = link.id; // id不对应
      r.name = link.name; // 父女
      r.oldName = link.name;
      r.source = link.source.name;
      r.target = link.target.name;
      const { age } = this.rel;
      // this.$nextTick(function () {
      //   this.$refs.editRelationShip.resetFields();
      // });
      this.rel.age = age;
      const data = {
        data: {
          cis: this.custCis, // 类型：String  必有字段  备注：客户号
          uId: (JSON.parse(sessionStorage.getItem('sessionData')).userId) * 1,
        },
      };
      // 查询关系接口 给修改弹窗赋值
      const result = await this.getWpspListCustSuppleFn(data);
      console.log('结果', result);
      const resultArr = result.data.allCustSupple;
      resultArr.forEach((v) => {
        if (v.id === link.ID) {
          console.log('找到对应子女数据', v);
          this.rel.idType = v.idType;
          this.rel.idCode = v.idCard;
          if (v.idCard === undefined) {
            this.rel.idCode = '';
          }
          if (v.idType === undefined) {
            this.rel.idType = '';
          }
          this.rel.name = this.relationWithNum(v.custRelation);
          this.rel.age = v.custAge;
          this.rel.target = v.custName;
        }
      });
      this.editing = true;
      this.showform = false;
    },
    getWpspListCustSuppleFn(parames) {
      return new Promise((resolve, reject) => {
        this.$_post(this.$API.wpspListCustSupple, parames).then((res) => {
          resolve(res);
        }).catch(error => console.log(reject(error)));
      });
    },
    // 修改子女// 修改方法
    onSaveClick() {
      // eslint-disable-next-line consistent-return
      this.$refs.editRelationShip.validate((valid) => {
        if (valid) {
          if ((this.rel.idCode !== '' && this.rel.idType === '') || (this.rel.idCode !== '' && this.rel.idType === '')) {
            this.verificationTextShowIdType = true;
            this.verificationTextShowIdTypeText = '请选择证件类型';
            return false;
          }
          this.verificationTextShowIdType = false;
          this.verificationTextShowIdTypeText = '';
          if ((this.rel.idType !== '' && this.rel.idCode === '') || (this.rel.idType !== '' && this.rel.idCode === '')) {
            this.verificationTextShowIdCode = true;
            this.verificationTextShowIdCodeText = '请输入证件号码';
            return false;
          }
          if (this.rel.idCode.length > 50) {
            this.verificationTextShowIdCode = true;
            this.verificationTextShowIdCodeText = '证件号码不可超过50位';
            return false;
          }
          if (this.rel.idType === '1' || this.rel.idType === 1) {
            const reg = /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/;
            const idCard = reg.test(this.rel.idCode);
            // 验证身份证是否符合规范
            if (idCard === false) {
              this.verificationTextShowIdCode = true;
              this.verificationTextShowIdCodeText = '请输入18位有效的身份证号';
              return false;
            }
          }
          this.verificationTextShowIdCode = false;
          this.verificationTextShowIdType = false;
          const parames = {
            data: { // 类型：Object  必有字段  备注：数据集
              cis: this.custCis, // 类型：String  必有字段  备注：客户号
              custName: this.rel.target, // 类型：String  必有字段  备注：家庭成员姓名
              custRelation: this.relationWithCis(this.rel.name), // 类型：String  必有字段  备注：关系(1、配偶 2、父亲3、母亲3、儿子4、女儿)
              id: this.validateObj.ID,
            },
          };
          this.$_post(this.$API.wpspUpdateCheckFamilySupple, parames).then(async (res) => {
            console.log('验证姓名', res);
            this.wpspUpdateFamilySupple();
          });
        }
      });
    },
    // 修改家庭关系
    wpspUpdateFamilySupple() {
      const parames = {
        data: { // 类型：Object  必有字段  备注：数据集
          id: this.validateObj.ID, // 类型：Number  必有字段  备注：id
          cis: this.custCis, // 类型：String  必有字段  备注：客户号
          custName: this.rel.target, // 类型：String  必有字段  备注：姓名
          custAge: this.rel.age, // 类型：Number  必有字段  备注：年龄
          custRelation: this.relationWithCis(this.rel.name), // 类型：String  必有字段  备注：关系(1、配偶 2、父亲3、母亲4、儿子5、女儿)
          idType: this.rel.idType, // 类型：String  可有字段  备注：证件类型(1、居民身份证 2、军官证3、护照)
          idCard: this.rel.idCode, // 类型：String  可有字段  备注：证件号码
          uId: JSON.parse(sessionStorage.getItem('sessionData')).userId,
        },
      };
      this.$_post(this.$API.wpspUpdateFamilySupple, parames).then(async (res) => {
        console.log(res, '修改家庭关系');
        if (res.status === '0' || res.status === 0) {
          this.editing = false;
          this.$refs.graph.updateLinkName(this.validateObj.ID, this.rel.name, this.rel.age, this.rel.target, this.rel.idType, this.rel.idCode);
          const img = this.searchPicture(this.relationWithCis(this.rel.name));
          console.log('修改后的img====', img);
          const ret = this.graph.links.find(v => v.id === this.tempLinkName);
          ret.name = this.rel.name;
          const target = this.graph.nodes.find(v => v.id === ret.target);
          target.name = this.rel.target;
          const pattern2 = new RegExp('[A-Za-z]+');
          let sliceName = '';
          if (pattern2.test(target.name)) {
            if (target.name.length <= 10) {
              // eslint-disable-next-line no-useless-concat
              sliceName = `${target.name} \n ` + `[${this.rel.age}岁` + ']';
            } else {
              // eslint-disable-next-line no-useless-concat
              sliceName = `${target.name.slice(0, 10)}... \n ` + `[${this.rel.age}岁` + ']';
            }
          } else if (target.name.length <= 5) {
            // eslint-disable-next-line no-useless-concat
            sliceName = `${target.name.slice(0, 5)} \n ` + `[${this.rel.age}岁` + ']';
          } else {
            // eslint-disable-next-line no-useless-concat
            sliceName = `${target.name.slice(0, 5)}... \n ` + `[${this.rel.age}岁` + ']';
          }
          target.name = sliceName;
          target.image = img;
          target.age = this.rel.age;
          target.target = this.rel.target;
          console.log('修改名字-------', target, this.rel);
          this.$refs.graph.show(this.graph);
          this.tempRel = this.rel;
          // eslint-disable-next-line no-useless-escape
          const newTargetName = this.targetName.slice(0, this.targetName.indexOf('[')).replace(/[\r\n]/g, '').replace(/\ +/g, '');
          const selectInfo = this.componentData.familys.find(v => v.custName === newTargetName);
          if (selectInfo) {
            selectInfo.customerRelation = `${this.relationWithCis(this.rel.name)}`;
            selectInfo.age = `${this.rel.age}`;
            selectInfo.opration = '2';
          }
          if (this.rel.name === '配偶') {
            console.log('修改的关系----', this.rel.name);
            this.$store.commit('setAddSpouse', '3');
          } else {
            this.$store.commit('setAddSpouse', '1');
          }
          this.$message({
            message: '成功',
            type: 'success',
          });
        } else {
          this.$message({
            message: res.errorMsg,
            type: 'error',
          });
        }
      });
    },
    // 删除方法
    onDelClick() {
      this.$confirm('确定要删除此家庭成员？', '删除家庭成员')
        // eslint-disable-next-line no-unused-vars
        .then((_) => {
          const parames = {
            data: { // 类型：Object  必有字段  备注：数据集
              id: this.validateObj.ID, // 类型：Number  必有字段  备注：id
            },
          };
          this.$_post(this.$API.wpspDeleteFamilySupple, parames).then((res) => {
            if (res.status === '0') {
              console.log('删除方法', res);
              this.opration = '3';
              let target;
              if (this.graph.nodes.length > 1) {
                new Promise((resolve) => {
                  if (this.graph.links !== 'undefined' && this.graph.nodes !== 'undefined') {
                    this.graph.links.forEach((el, index) => { // 在结点中 找到对应关系
                      if (el.id === this.rel.id) {
                        // eslint-disable-next-line prefer-destructuring
                        target = el.target;
                        this.graph.links.splice(index, 1);
                      }
                    });
                    this.graph.nodes.forEach((el, index) => {
                      // 结点中找到 关系人物
                      if (el.id === target) {
                        this.componentData.familys.forEach((v, i) => {
                          // eslint-disable-next-line no-useless-escape
                          const inputName = this.rel.target.slice(0, this.rel.target.indexOf('[')).replace(/[\r\n]/g, '').replace(/\ +/g, '');
                          if (v.custName.trim() === inputName.trim()) {
                            // 删除保存 标记数据为 '3'
                            this.componentData.familys.splice(i, 1,
                              { ...this.componentData.familys[i], opration: this.opration });
                          }
                        });
                        this.graph.nodes.splice(index, 1);
                      }
                    });
                    resolve(true);
                  } else {
                    resolve(false);
                  }
                }).then((r) => {
                  if (r) {
                    // eslint-disable-next-line no-param-reassign,no-return-assign
                    this.graph.nodes.forEach((v, i) => v.id = i);
                    this.graph.links.forEach((v, i) => {
                      // eslint-disable-next-line no-param-reassign
                      v.target = i + 1;
                      // eslint-disable-next-line no-param-reassign
                      v.id = i;
                    });
                    this.$refs.graph.show(this.graph);
                    // this.decidehasCouple()
                  }
                });
              }
              this.$refs.graph.show(this.graph);
              this.editing = false;
              console.log('删除哪个关系-', this.rel.name);
              if (this.rel.name === '配偶') {
                this.$store.commit('setAddSpouse', '1');
              }
              this.$message({
                message: '删除成功',
                type: 'success',
              });
            } else {
              this.$message({
                message: res.errorMsg,
                type: 'error',
              });
            }
          });
        })
        // eslint-disable-next-line no-unused-vars
        .catch((_) => {
          this.editing = false;
        });
    },
    onSaveAdd(age, relation, Ngender, name, id, idType, idCode) { // 新增
      this.opration = 1;
      // Ngender 默认传入的性别
      const relname = this.rel.name || relation; // 成员关系名称
      const reltarget = this.rel.target || name; // 成员姓名
      let image = '';
      let gender;
      const customerRelation = this.relationWithCis(relname);
      // 客户关系 1 配偶 2 父亲 3母亲 4儿子 5 女儿
      if (customerRelation === 4 || customerRelation === '4') {
        gender = 1; // 男
      } else if (customerRelation === 5 || customerRelation === '5') {
        gender = 2; // 女
      }
      if (customerRelation === 1) { // 当关系为配偶时 判断性别
        console.log(this.$store.state.wpspUserInfo, '客户信息');
        gender = (this.$store.state.wpspUserInfo.gender === 2 || this.$store.state.wpspUserInfo.gender === '2') ? 1 : 2;
      }
      if (relname && reltarget) {
        const nodeslength = this.graph.nodes.length;
        const linkslength = this.graph.links.length;
        image = this.searchPicture(customerRelation);
        const ageLast = age;
        let sliceName = '';
        const pattern2 = new RegExp('[A-Za-z]+');
        if (pattern2.test(reltarget)) {
          if (reltarget.length <= 10) {
            // eslint-disable-next-line no-useless-concat
            sliceName = `${reltarget} \n ` + `[${ageLast}岁` + ']';
          } else {
            // eslint-disable-next-line no-useless-concat
            sliceName = `${reltarget.slice(0, 10)}... \n ` + `[${ageLast}岁` + ']';
          }
        } else if (reltarget.length <= 5) {
          // eslint-disable-next-line no-useless-concat
          sliceName = `${reltarget.slice(0, 5)} \n ` + `[${ageLast}岁` + ']';
        } else {
          // eslint-disable-next-line no-useless-concat
          sliceName = `${reltarget.slice(0, 5)}... \n ` + `[${ageLast}岁` + ']';
        }
        this.graph.nodes.push({
          id: nodeslength,
          name: sliceName,
          size: 50,
          image,
          ID: id,
        });
        this.graph.links.push({
          id: linkslength,
          name: relname,
          source: '0',
          target: nodeslength,
          ID: id,
        });

        /** ***********发送后台数据结构************** */
        this.componentData.cis = this.custCis;
        const family = this.componentData.familys;
        const newId = (id === null || id === undefined) ? 0 : id;
        const insertData = {
          custName: reltarget,
          gender: Ngender || gender, // 女为2 男 为1
          customerRelation,
          age: this.rel.age || age,
          id: newId,
          ID: id,
          opration: this.opration,
          idType: this.rel.idType || idType,
          idCode: this.rel.idCode || idCode,
        };
        Vue.set(family, family.length, insertData);
        this.allfamilyList = this.componentData.familys;
        /** ************************* */
        this.$refs.graph.show(this.graph);
        // 清除数据
        this.rel.name = '';
        this.rel.target = '';
      }
      this.rel.name = '';
      this.rel.target = '';
      this.showform = false;
      this.editing = false;
    },
    // 删除功能
    searchPicture(relation) { // 通过关系查看页面
      let image;
      // eslint-disable-next-line default-case
      switch (relation) {
        case 1:
          if (this.$store.state.wpspUserInfo.gender === '2' || this.$store.state.wpspUserInfo.gender === 2) {
            image = './images/people/man.png';
          } else {
            image = './images/people/woman.png';
          }
          break;
        case 2:
          image = './images/people/oldman.png';
          break;
        case 3:
          image = './images/people/oldwoman.png';
          break;
        case 4:
          image = './images/people/boy.png';
          break;
        case 5:
          image = './images/people/girl.png';
      }
      return image;
    },
    addnewRel() {
      // eslint-disable-next-line guard-for-in,no-restricted-syntax
      for (const i in this.rel) {
        this.rel[i] = '';
      }
      this.showform = true;
      this.editing = false;
    },
    handleSelectChange(educationValue, workValue, knowledgeValue, experienceValue) {
      // educationValue  学历
      // workValue  职业
      // knowledgeValue  投资知识
      // experienceValue  投资经验
      const parames = {
        data: { // 类型：Object  必有字段  备注：无
          cis: this.custCis, // 类型：String  必有字段  备注：客户号
          education: educationValue, // 类型：String  可有字段
          occupation: workValue, // 类型：String  可有字段
          investKnowledge: knowledgeValue, // 类型：String  可有字段
          investExperience: experienceValue, // 类型：String  可有字段
          uId: JSON.parse(sessionStorage.getItem('sessionData')).userId,
        },
      };
      this.$_post(this.$API.wpspUpdateCustsupple, parames).then((res) => {
        if (res.status === '1') {
          this.$message({
            message: '操作失败,请重试！',
            type: 'error',
            showClose: true,
            duration: 3000,
          });
        }
      });
    },
  },
};
</script>
<style lang="scss">
.basic-information {
  .yh-dialog .el-input,
  .yh-dialog .el-textarea {
    width: 200px;
  }
  .el-dialog__header {
    text-align: left;
  }
  .el-form-item__content {
    text-align: left;
  }
}
</style>
<style scoped lang="scss">
/*关系图*/
.verificationText {
  color: #f56c6c;
  font-size: 12px;
  line-height: 1;
}
.verificationText-style-enter-active {
  transition: all 0.2s ease;
}
.verificationText-style-leave-active {
  transition: all 0.2s ease;
}
.verificationText-style-enter,
.verificationText-style-leave-to {
  transform: translateY(-15px);
}
.graphContainer {
  position: relative;
  padding: 0;
  width: 100%;
  height: 300px;
  border-radius: 9px;
  text-align: center;
}
.add {
  display: inline-block;
  border-radius: 50%;
  height: 20px;
  width: 20px;
  background-color: #eee;
  text-align: center;
  cursor: pointer;
  position: absolute;
  top: 125%;
  left: 40%;
  transform: translate(-50%, -50%);
}
.addText{
  cursor:pointer;
  width:84px;
height:20px;
font-size:14px;
font-family:PingFangSC-Regular,PingFang SC;
font-weight:400;
color:rgba(30,136,255,1);
line-height:20px;
   position: absolute;
  top: 125%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.basic-information {
  background-color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: nowrap;
  padding: 15px 30px;
  .info-left {
    width: 51%;
    height: 400px;
    margin-left: -12px;
    .info-left-top {
      > div {
        h1 {
          font-size: 30px;
          color: #303133;
          margin-right: 10px;
          display: inline-block;
          vertical-align: middle;
        }
        p {
          display: inline-block;
          vertical-align: middle;
          background: #ffecec;
          font-size: 14px;
          color: #f95353;
          width: 68px;
          height: 28px;
          line-height: 28px;
          text-align: center;
        }
      }
      > ul {
        display: flex;
        justify-content: space-between;
        align-items: center;
        align-content: center;
        flex-wrap: wrap;
        margin-top: 25px;
        li {
          width: 50%;
          padding-bottom: 15px;
        }
      }
    }
    .info-left-bottom {
      margin-top: 30px;
      ul {
        display: flex;
        justify-content: space-between;
        align-items: center;
        align-content: center;
        flex-wrap: wrap;
        li {
          width: 50%;
          padding-bottom: 20px;
          p {
            font-size: 14px;
            color: #606266;
            padding-bottom: 5px;
          }
        }
      }
    }
  }
  .info-right {
    width: 50%;
    height: 400px;
    background-color: #edf6ff;
  }
}
</style>
